module.exports = __webpack_public_path__ + "img/download-2-4.031c5c05.png";